// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // baseUrl: 'http://127.0.0.1:8000/api/',
  // rootUrl: 'http://127.0.0.1:8000/',
  baseUrl: 'https://koan.saferinputs.wekae.com/api/',
  rootUrl: 'https://koan.saferinputs.wekae.com/',
  // baseUrl: 'https://api.safeinputs.koan.co.ke/api/',
  // rootUrl: 'https://api.safeinputs.koan.co.ke/',
  defaultImage: '../assets/loader.gif',
  errorImage: '../assets/default.png',
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
